import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { ConfirmModal, ProductImage } from '@cps'
import './index.scss'

interface IProps extends TConfirmModalProps {
  pics: any[];
}

interface IState {
}

const OrderEnterTableConfirmModal: FC<IProps> = ({ pics }) => {
  return (
    <ConfirmModal
      isLight
      canClose
      confirmText={i18n.t('menu.nowEnterTable')}
      className='single-style-modal order-enter-table-confirm-modal'
    >
      <div className='modal-content'>
        {i18n.t('menu.findOrderEnterTable')}
        <div className='pic-list'>
          {
            pics?.map((item, index) => <ProductImage key={index} width={64} height={64} imgSrc={item} />)
          }
        </div>
      </div>
    </ConfirmModal>
  )
}

export default observer(OrderEnterTableConfirmModal)
